
export default {
    layout: 'error',
    props: {
        error: '',
    },
}
